// extracted by mini-css-extract-plugin
module.exports = {"sectionClosingLine":"border_sectionClosingLine___Ejm6"};